import React, { useContext, useState, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import UserAddressList from '../../components/Common/Lists/UserAddress'
import Sticky from '../../components/Common/Sticky'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context'

const MyAddress = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [list, setList] = useState([])

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await ApiService.getMyAddress()
      setList(response.data.data)
    } catch(e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async function fetch() {
      await fetchData()
    })()
  }, []) // eslint-disable-line

  const setUserDefault = async (id) => {
    try {
      setLoading(true)
      await ApiService.setUserDefaultAddress({ userAddressId: id })
      toastr.success(`Dirección de envío actualizada como predeterminada.`, '¡Éxito!')
      window.analytics.track(`Delivery address selected`)
      props.history.push(`/carrito`)
    } catch(e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const newUserAddress = () => {
    window.analytics.track(`Go to user addresses`)
    props.history.push('/direcciones-envio/agregar')
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Mis direcciones"
            breadcrumbItem={`Mis direcciones`}
            parentLink={`/mis-direcciones`}
          />
          <UserAddressList
            data={list}
            itemAction={setUserDefault}
          />
        </Container>
      </div>
      <Sticky
        showSecondButton
        secondButtonText="AGREGAR DIRECCIÓN"
        secondButtonClass="btn-success"
        secondButtonAction={newUserAddress}
      />
    </React.Fragment>
  )
}

export default withRouter(MyAddress)
